import React, {useRef, useState} from "react";
import {Col, Overlay, Row, Tooltip} from "react-bootstrap";
import {
    SiLinux,
    SiVisualstudiocode,
    SiPostman,
    SiHeroku,
    SiVercel, SiSwagger,
} from "react-icons/si";

function Toolstack() {
    const [lin, setLinux] = useState(false);
  const targetLinux = useRef(null);

  const [vs, setVs] = useState(false);
  const targetVs = useRef(null);

  const [post, setPost] = useState(false);
  const targetPost = useRef(null);

  const [hurko, setHurko] = useState(false);
  const targetHurko = useRef(null);

  const [swagger, setSwagger] = useState(false);
  const targetSwagger = useRef(null);

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }} >
      <Col xs={4} md={2} className="tech-icons" ref={targetLinux} onMouseOver={() => setLinux(!lin)} onMouseLeave={() => setLinux(false)}>
        <SiLinux />
      </Col>

        <Overlay target={targetLinux.current} show={lin} placement="top" >
        {(props) => (
          <Tooltip id="overlay-example" {...props} >
            Linux
          </Tooltip>
        )}
      </Overlay>

      <Col xs={4} md={2} className="tech-icons" ref={targetVs} onMouseOver={() => setVs(!vs)} onMouseLeave={() => setVs(false)}>
        <SiVisualstudiocode />
      </Col>

        <Overlay target={targetVs.current} show={vs} placement="top" >
        {(props) => (
          <Tooltip id="overlay-example" {...props} >
            Visual studio code
          </Tooltip>
        )}
      </Overlay>

      <Col xs={4} md={2} className="tech-icons" ref={targetPost} onMouseOver={() => setPost(!post)} onMouseLeave={() => setPost(false)}>
        <SiPostman />
      </Col>

        <Overlay target={targetPost.current} show={post} placement="top" >
        {(props) => (
          <Tooltip id="overlay-example" {...props} >
            Post man
          </Tooltip>
        )}
      </Overlay>

        <Col xs={4} md={2} className="tech-icons" ref={targetSwagger} onMouseOver={() => setSwagger(!swagger)} onMouseLeave={() => setSwagger(false)}>
        <SiSwagger />
      </Col>

        <Overlay target={targetSwagger.current} show={swagger} placement="top" >
        {(props) => (
          <Tooltip id="overlay-example" {...props} >
            Swagger
          </Tooltip>
        )}
      </Overlay>

      <Col xs={4} md={2} className="tech-icons" ref={targetHurko} onMouseOver={() => setHurko(!hurko)} onMouseLeave={() => setHurko(false)}>
        <SiHeroku />
      </Col>

        <Overlay target={targetHurko.current} show={hurko} placement="top" >
        {(props) => (
          <Tooltip id="overlay-example" {...props} >
            Heroku
          </Tooltip>
        )}
      </Overlay>



    </Row>
  );
}

export default Toolstack;
